module.exports = __webpack_public_path__ + "media/images/header__background-d2594de279af5312377be43eb7f31347.jpg";